<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="群成员管理">
        <div class="row align--center mb-1">
          <div class="flex xs12 sm6">
          </div>
          <div class="flex xs12 sm6">
            <div class="d-flex justify--end">
              <va-button
                color="info"
                small
                @click="showJoinChanel = true"
              >
                添加群成员
              </va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="members"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listChannelMembers"
          api-mode
        >
          <template slot="avatar" slot-scope="props">
            <va-avatar>
              <img :src="formatAvatar(props.rowData.avatar)">
            </va-avatar>
          </template>

          <template slot="nickname" slot-scope="props">
            <va-button color="dark" flat small :to='{path:`/admin/users/updateUser/${props.rowData.uid}`}'>
              {{ formatNickname(props.rowData.nickname) }}
            </va-button>
          </template>

          <template slot="joinTime" slot-scope="props">
            {{ formatTime(props.rowData.joinTime) }}
          </template>

          <template slot="lastSendMsgTime" slot-scope="props">
            {{ formatLastSendMsgTime(props.rowData.lastSendMsgTime) }}
          </template>

          <template slot="shutUpUntil" slot-scope="props">
            {{ formatShutUpTimeUtil(props.rowData.shutUpUntil) }}
          </template>

          <template slot="actions" slot-scope="props">
            <va-popover message="删除群成员" placement="top">
              <va-button
                flat
                small
                color="gray"
                icon="fa fa-user-times"
                @click="deleteModal = true; kickOutUid=props.rowData.uid"/>
            </va-popover>
            <va-popover message="禁言成员" placement="top" v-if="!hasBeenBan(props.rowData.shutUpUntil)">
              <va-button
                flat
                small
                color="gray"
                icon="fa fa-ban"
                @click="banModal = true; banUid=props.rowData.uid"
              />
            </va-popover>
            <va-popover message="取消禁言" placement="top" v-else>
              <va-button
                flat
                small
                color="gray"
                icon="fa fa-smile-o"
                @click="showCancelBan = true; banUid=props.rowData.uid"
              />
            </va-popover>
            <va-popover message="设置管理员" placement="top" v-if="!isAdmin(props.rowData.role)">
              <va-button
                flat
                small
                color="gray"
                icon="fa fa-user"
                @click="showSetAdmin = true; updateMemberRoleId=props.rowData.uid; role='Admin'"
              />
            </va-popover>
            <va-popover message="取消管理员" placement="top" v-else>
              <va-button
                flat
                small
                color="gray"
                icon="fa fa-user-o"
                @click="showCancelAdmin = true; updateMemberRoleId=props.rowData.uid; role='Member'"
              />
            </va-popover>
          </template>
        </va-data-table>
        <va-modal
          v-model="showSetAdmin"
          title="设置管理员"
          okText="提交"
          position="center"
          message="设置用户为此群管理员？"
          @ok="updateMemberRole"
        />
        <va-modal
          v-model="showCancelAdmin"
          title="取消管理员"
          okText="提交"
          position="center"
          message="设置取消用户的群管理员？"
          @ok="updateMemberRole"
        />
        <va-modal
          v-model="showCancelBan"
          title="取消禁言"
          okText="提交"
          position="center"
          message="是否解禁该用户？"
          @ok="confirmCancelBan"
        />
        <va-modal
          v-model="deleteModal"
          title="删除群成员"
          okText="提交"
          position="center"
          message="请确认是否要删除该成员？"
          @ok="confirmDelete"
        />
        <va-modal
          v-model="showJoinChanel"
          title="添加群成员"
          okText="提交"
          position="center"
          size="large"
          @ok="confirmJoinChannel"
        >
          <va-select
            v-model="joinChannelUid"
            label="请选择用户名"
            textBy="nickname"
            :options="libaUserNicknames"
            searchable
            width="350px"
          />
        </va-modal>
        <va-modal
          v-model="banModal"
          title="禁言成员"
          okText="提交"
          position="center"
          message="请确认是否禁言该成员？"
          @ok="confirmBanSend"
        >
          <va-date-picker
            label="禁言至"
            :config="{enableTime: true}"
            v-model="banSendUtil"
          />
        </va-modal>
      </va-card>
    </div>
  </div>
</template>

<script>

import { parseDate, dateFormat } from '../../utils/common'
import groupApi from '../../api/group'
import userApi from '../../api/user'

export default {
  data () {
    return {
      message: ['请输入已经注册的用户ID'],
      members: [],
      loading: true,
      channelId: null,
      deleteModal: false,
      showJoinChanel: false,
      deleteId: null,
      kickOutUid: null,
      joinChannelUid: [],
      banModal: false,
      banUid: null,
      banSendUtil: null,
      showCancelBan: false,
      cancelBanUid: null,
      showSetAdmin: false,
      showCancelAdmin: false,
      role: null,
      updateMemberRoleId: null,
      pageSize: 10,
      pageNumber: 1,
      totalPages: 1,
      libaUsers: [],
      libaUserNicknames: [],
      normalMode: true
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:avatar',
        },
        {
          name: '__slot:nickname',
          title: '用户名',
          width: '16%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:joinTime',
          title: '加入时间',
          width: '15%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:lastSendMsgTime',
          title: '最后发言时间',
          width: '15%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:shutUpUntil',
          title: '禁言截至时间',
          width: '15%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'role',
          title: '成员身份',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    const params = this.$route.params
    this.channelId = params.channelId
    this.listChannelMembers(this.pageNumber, false)
    //加载libaUser
    this.listLibaUser()
  },
  methods: {
    libaUserNickname () {
      const nicknames = []
      for (let i = 0; i < this.libaUsers.length; i++) {
        const item = {}
        item.id = this.libaUsers[i].uid
        item.nickname = this.libaUsers[i].nickname + ' (' + item.id + ')'
        nicknames.push(item)
      }
      console.log(nicknames)
      this.libaUserNicknames = nicknames
    },
    formatAvatar (avatar) {
      return avatar + '?x-oss-process=style/avatar'
    },
    formatNickname (nickname) {
      if (nickname == null) {
        return ''
      }
      if (nickname.length <= 10) {
        return nickname
      } else {
        return nickname.substr(0, 10) + '...'
      }
    },
    updateMemberRole () {
      if (this.updateMemberRoleId == null || this.role == null) {
        alert('uid为空')
      }
      const data = {
        uid: this.updateMemberRoleId,
        channelId: this.channelId,
        role: this.role,
      }
      groupApi.updateMemberRole(data).then(response => {
        if (response.success === true) {
          this.listChannelMembers(this.pageNumber, false)
        }
      }).catch(error => {
        alert(error.msg)
      })
    },
    confirmCancelBan () {
      const data = {
        uid: this.banUid,
        channelId: this.channelId,
        shutUpUntil: 0,
      }
      groupApi.forbidSendMsg(data).then(response => {
        if (response.success === true) {
          this.listChannelMembers(this.pageNumber, false)
        }
      }).catch(error => {
        alert(error.msg)
      })
    },
    confirmBanSend () {
      const banSendUtil = parseDate(this.banSendUtil)
      const now = parseDate(new Date())
      if (banSendUtil <= now) {
        alert('封禁时间必须是未来某个时间')
      }
      const data = {
        uid: this.banUid,
        channelId: this.channelId,
        shutUpUntil: banSendUtil - now,
      }
      groupApi.forbidSendMsg(data).then(response => {
        if (response.success === true) {
          this.listChannelMembers(this.pageNumber, false)
        }
      }).catch(error => {
        alert(error.msg)
      })
    },
    isAdmin (role) {
      if (role === 'Admin') {
        return true
      }
      return false
    },
    hasBeenBan (shutUpUntil) {
      if (shutUpUntil === 0 || shutUpUntil < parseDate(new Date())) {
        return false
      }
      return true
    },
    formatTime (time) {
      return dateFormat('YYYY-mm-dd HH:MM', new Date(time * 1000))
    },
    formatLastSendMsgTime (time) {
      if (time === 0) {
        return '未发言'
      }
      return dateFormat('YYYY-mm-dd HH:MM', new Date(time * 1000))
    },
    formatShutUpTimeUtil (time) {
      if (time === 0) {
        return '未禁言'
      }
      return dateFormat('YYYY-mm-dd HH:MM', new Date(time * 1000))
    },
    listChannelMembers(pageNumber = 1, normalMode = true) {
      const params = {
        pageSize: this.pageSize,
        pageNumber: normalMode ? pageNumber : this.pageNumber,
        channelId: this.channelId
      }
      this.pageNumber = pageNumber
      this.loading = true
      groupApi.listChannelMembers(params)
        .then(response => {
          this.members = response.members
          this.totalPages = response.totalPage
          this.loading = false
        })
    },
    listLibaUser () {
      const params = {
        pageNumber: 1,
        pageSize: 10000,
      }
      userApi.listUser(params)
        .then(response => {
          this.libaUsers = response.users
          this.libaUserNickname()
        })
    },
    confirmDelete () {
      if (this.kickOutUid == null) return
      const data = {
        uid: this.kickOutUid,
        channelId: this.channelId,
      }
      groupApi.kickOutChannel(data)
        .then(response => {
          if (response.success === true) {
            this.listChannelMembers(this.pageNumber, false)
          }
        }).catch(error => {
          alert(error.msg)
        })
    },
    confirmJoinChannel () {
      if (this.joinChannelUid == null) return
      const data = {
        uid: this.joinChannelUid.id,
        channelId: this.channelId,
      }
      groupApi.joinChannel(data)
        .then(response => {
          if (response.success === true) {
            this.listChannelMembers(this.pageNumber, false)
          }
        }).catch(error => {
          alert(error.msg)
        })
    },
  },
}

</script>
